import { useDispatch } from 'react-redux';
import { lt, showSuccessAlert } from '@mews/framework';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { CommanderThunkDispatch, Payment } from '@mews-commander/types';
import { localizeCurrencyValue } from '@mews-commander/utils';
import { setPayment } from '@mews-commander/legacy-entities/src/ducks/payments';
import { useInvalidatePaymentsTableRecordsQueries } from '../../../../queries';
import { useInvalidateGetPaymentPlansTableRecords } from '../../../tables/PaymentPlans/queries';

export const useCreateExternalPayment = ({
    accountId,
    onSuccess,
    onSubmitting,
    onSubmitted,
}: {
    accountId: string;
    onSuccess?: () => void;
    onSubmitting?: () => void;
    onSubmitted?: () => void;
}) => {
    const dispatch: CommanderThunkDispatch = useDispatch();
    const invalidatePaymentsTableRecordsQueries = useInvalidatePaymentsTableRecordsQueries();
    const invalidateGetPaymentPlansTableRecords = useInvalidateGetPaymentPlansTableRecords();

    return useRepositoryMutation('externalPayments', 'add', {
        onMutate: () => {
            onSubmitting?.();
        },
        onSuccess: (payment, { amount, currencyCode, type, paymentPlanId }) => {
            showSuccessAlert({
                description: lt('ExternalPaymentSuccessMessage', {
                    type,
                    amount: localizeCurrencyValue({ value: amount, currency: currencyCode }),
                }),
            });
            invalidatePaymentsTableRecordsQueries({ accountId });
            invalidateGetPaymentPlansTableRecords(paymentPlanId);
            dispatch(setPayment(payment as unknown as Payment));
            onSuccess?.();
        },
        onSettled: () => {
            onSubmitted?.();
        },
    });
};
